module.exports = __webpack_public_path__ + "static/media/film-prod-nyc-1.c135d864.jpeg";